export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <div className="flex items-center gap-3 mb-3 justify-center lg:justify-start">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-smartphone-line text-background-50 text-lg"></i>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">随时随地在线吃瓜</h2>
            </div>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-[480px] mx-auto lg:mx-0">
              吃瓜视频在线观看全面适配移动端，无需下载APP，打开浏览器就能畅享
              51吃瓜、91吃瓜、黑料吃瓜等全部高清视频内容。手机上即点即看，
              高清流畅播放，随时随地满足你的在线吃瓜观看需求。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-play-circle-line"></i>
                立即体验
              </a>
              <a
                href="#features"
                onClick={(e) => { e.preventDefault(); document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-background-300 text-foreground-700 font-semibold text-sm hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
              >
                了解更多
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-accent-100 flex items-center justify-center">
              <i className="ri-smartphone-line text-accent-500 text-6xl md:text-7xl"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}